module.exports = __webpack_public_path__ + "img/kx5600.8f0a99e9.png";